import styled from 'styled-components';

export const FeatureWheelContainer = styled.div`
  width: 632px;
  height: ${props => props.height}px;
  position: relative;

  .feature-wheel--wheel-logo {
    width: ${props => props.logoWidth}px;
    height: ${props => props.logoHeight}px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    width: 500px;
  }
`;

export const FeatureWheelItemContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transform: ${props => `rotate(${props.transform}deg)`};
  transition: 1s;
`;

export const FeatureWheelItem = styled.div`
  width: ${props => props.width * (props.isActive ? props.focusIconScale : 1)}px;
  height: ${props => props.height * (props.isActive ? props.focusIconScale : 1)}px;
  left: ${props =>
    props.x - (props.isActive ? (props.width * (props.focusIconScale - 1)) / 2 : 0)}px;
  top: ${props =>
    props.y - (props.isActive ? (props.height * (props.focusIconScale - 1)) / 2 : 0)}px;
  padding: ${props => 14 * (props.isActive ? props.focusIconScale : 1)}px;
  position: absolute;
  transform: ${props => `rotate(${-props.transform}deg)`};
  transition: transform 1s, width 0.5s, height 0.5s, left 0.5s, top 0.5s, padding 0.5s,
    box-shadow 0.1s;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  .feature-wheel--wheel-item-icon {
    width: 100%;
    height: 100%;
  }

  .feature-wheel--wheel-item-tooltip {
    display: none;
    position: absolute;
    text-align: center;
    top: -2px;
    transform: translateY(-100%);
    white-space: nowrap;
  }

  &:hover {
    ${props =>
      !props.isActive
        ? `
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);

      .feature-wheel--wheel-item-tooltip {
        display: block;
      }
    `
        : ''};
  }
`;
